import { render, staticRenderFns } from "./WsDemoExamsList.vue?vue&type=template&id=6957057e&scoped=true"
import script from "./WsDemoExamsList.vue?vue&type=script&lang=js"
export * from "./WsDemoExamsList.vue?vue&type=script&lang=js"
import style0 from "./WsDemoExamsList.vue?vue&type=style&index=0&id=6957057e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6957057e",
  null
  
)

export default component.exports